import SectionWithItems from "../../scripts/SectionWithItems";
import experiences from "../../data/experience";

const ExperiencePage = () => {
    return (
        <>
            <SectionWithItems title="Experience" projects={experiences}/>
        </>
    )
}

export default ExperiencePage;
